import React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@material-ui/core';
import { 
    Security as SecurityIcon,
} from '@material-ui/icons';

import { useStyles } from './PhoneVerificationBanner.styles';
import usePhoneVerificationBanner from './usePhoneVerificationBanner';

function PhoneVerificationBanner() {
    const classes = useStyles();
    const { showBanner, handleVerifyNow, handleDismiss } = usePhoneVerificationBanner();

    if (!showBanner) {
        return null;
    }

    return (
        <div className={classes.root} role="alert">
            <div className={classes.iconContainer}>
                <SecurityIcon />
            </div>
            <div className={classes.textSection}>
                <span className={classes.title}>Important Notice</span>
                <span className={classes.body}>
                    <span className={classes.bodyHighlight}>Enhance your security:</span>
                    {' Verify your phone number to enable SMS authentication.'}
                </span>
            </div>
            <div className={classes.buttonGroup}>
                <Button
                    className={classes.dismissButton}
                    onClick={handleDismiss}
                    aria-label="Dismiss phone verification banner"
                >
                    Dismiss
                </Button>
                <Button
                    className={classes.verifyButton}
                    variant="contained"
                    disableElevation
                    onClick={handleVerifyNow}
                >
                    Verify
                </Button>
            </div>
        </div>
    );
}

export default observer(PhoneVerificationBanner);
